export default __webpack_public_path__ + "static/media/tally.88f03811.png";